<template>
  <div :class="getCss('wrap')" :style="wrapStyle">
    <template>
      <div :class="getCss(['login', 'title--default', !isMobile ? 'title--pc' : ''])"
           :style="styles.fontStyle" v-if="isLogin">
        <div :style="styles.fontStyle">
          你好，
          <template>
            <span :class="getCss('userinfo-text')" v-if="!isRoleReady && isWX " v-html="userName"></span>
            <span :class="getCss('userinfo-text')" v-if="!isRoleReady && !isWX" v-text="userName"></span>
            <span :class="getCss('userinfo-text')">{{ partitionName }}</span>
            <span :class="getCss('userinfo-text')">{{ roleName }}</span>
          </template>
        </div>
        <div>
          <a
            v-if="showRole"
            :class="getCss('userinfo-text-button')"
            @click="handleBindRole"
          >{{ userBindText }}</a>
          <!--在游戏内不显示-->
          <a
            v-if="!configurationData.disableRewardRecord"
            :class="getCss('userinfo-text-button')"
            @click="handleClaimRecord"
          >领奖记录</a>
          <!--在游戏内不显示-->
          <a v-if="!isInGame && !cLogout" :class="getCss('userinfo-text-button')" @click="handleLogout">注销</a>
        </div>
      </div>
      <div :class="getCss('not-login')" :style="styles.fontStyle" v-else>
        你好，请
        <template v-if="isWX">
          <span>
            <a id="ptLoginBtn" @click="loginByQQ">【QQ登录】</a>
          </span>
          <!-- 如果是端游的 不显示微信登录并且 禁止微信登录         -->
          <span v-if="!isClientGame">
            或
            <a id="wxloginBtn" @click="loginByWx">【微信登录】</a>
          </span>
        </template>
        <template v-else>
          <span>
            <a id="ptLoginBtn" @click="loginByQQ">【QQ登录】</a>
          </span>
        </template>
      </div>
    </template>
    <c-base-dialog
      v-model="showSwitchLogin"
      :option="options"
      @close="showSwitchLogin=false"
      v-transfer-dom
    >
      <template slot="body">
        <div class="pop-login">
          <a @click="loginByQQ" class="qq-login"></a>
          <a @click="loginByWx" class="wechat-login"></a>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common, baseComponents } from '@tencent/ceiba-base-components';
// import { componentBaseMixin, common, baseComponents } from '../../../../ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

export default {
  name: 'CSupercoreUserArea',
  components: { [CDialog.name]: CDialog },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'super-user-area-',
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      showSwitchLogin: false,
      showControl: false,
    };
  },
  computed: {
    // 端游判断
    isClientGame() {
      return this.$actInfo.game_type === 1;
    },
    isInGame() {
      return common.platform.isGame;
    },
    cLogout() {
      console.log(common.tool.getQueryparams('C_LOGOUT'));
      if (common.tool.getQueryparams('C_LOGOUT')) {
        return true;
      }
      return false;
    },
    isWX() {
      return this.$platform.isWX;
    },
    wrapStyle() {
      const fontStyle = this.styles.fontStyle || {};
      return {
        ...this.styles.base,
        ...fontStyle,
      };
    },
    showRole() {
      return this?.actInfo?.extendConfig?.forceRole;
    },
    disableLogout() {
      return this.$ast.isAPP();
    },
    userBindText() {
      return this.isRoleReady ? '更改绑定' : '绑定角色';
    },
    userName() {
      return this.isLogin ? this.userInfo.nickName : '';
    },
    partitionName() {
      return this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
    },
    roleName() {
      return this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.role_name || '') : '';
    },
    showLogout() {
      return window.platform !== window.PLATFORM_WX;
    },
    options() {
      return Object.assign({}, this.dialogConfig, {
        header: false,
        fotter: false,
        height: '350px',
        width: '650px',
        closeLocation: 'right-top',
        dialogStyle: Object.assign({}, this.dialogConfig?.dialogStyle || {}, {
          backgroundImage:
            'url("https://act.xinyue.qq.com/activity/ingame/10009/003406d5f8d3828ccdad840b7888f807.png")',
        }),
      });
    },
  },
  mounted() {
    console.log('version 1.0.10 configurationData=', this.configurationData, this.actInfo, this?.actInfo?.extendConfig?.forceRole);
    this.initialize();
    // this.$isInEditor = true;
  },
  methods: {
    initialize() {
      // 用户登陆
      this.$eventBus.$onLogined(this.handleLogin);
    },
    switchLogin() {
      this.showSwitchLogin = true;
    },
    async loginByQQ() {
      this.login({
        loginType: 'qq',
      });
    },
    async loginByWx() {
      this.login({
        loginType: 'wx',
      });
    },
    async handleLogout() {
      this.logout();
    },

    async handleLogin() {
      // 自动绑定角色
      if (!this.actInfo.extendConfig.forceRole) return;
      this.checkRoleInfo();
    },

    async handleBindRole() {
      baseComponents.gameRoleSelect.showGameRoleSelect(this.actInfo.game_code, {})
        .then((roleInfo) => {
          console.log('select role=', roleInfo);
          this.saveCurrentRole({
            isRoleReady: true,
            roleInfo,
          });
        });
    },
    async handleClaimRecord() {
      baseComponents.pacakgeClaimRecords.showPackageClaimRecords(this.actInfo.game_code, {
        hidePackageIds: (this.configurationData.hidePackageIdshidePackageIds || '').split(','),
        params: {
          activity_id: this.actInfo.activity_id.toString(),
          business_id: this.actInfo.ast,
        },
        pageSize: 6,
        option: {
          header: false,
          footer: false,
          height: this.deviceMode === 'pc' ? '360px' : '3.6rem',
          width: this.deviceMode === 'pc' ? '720px' : '7.2rem',
          closeLocation: 'top-right',
          close: true,
          dialogStyle: Object.assign(
            {},
            {
              color: this.configurationData.recordsFontColor || '#000000',
              backgroundImage: `url(${this.configurationData.packageClaimBackgroundImage})`,
            },
          ),
        },
      });
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';

.pop-login {
}

.pop-login .qq-login {
  margin-right: 90px;
  display: inline-block;
  width: 145px;
  height: 145px;
  background: url(https://act.xinyue.qq.com/activity/ingame/10009/7625d4358e727be901f2fa8fe4c19653.png) no-repeat center top;
}

.pop-login .wechat-login {
  display: inline-block;
  width: 145px;
  height: 145px;
  background: url(https://act.xinyue.qq.com/activity/ingame/10009/685e8ab1c56cbc685b97f5ec9d37f502.png) no-repeat center top;
}
</style>
